export function emptyOrUndefined<T>(
  value: T[] | undefined | null
): value is undefined | null {
  return value === undefined || value === null || value.length === 0;
}
